import * as React from 'react'
import { Card, Box, Typography, SxProps, Theme } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

export type WaterTreeEditActionProps = {
    label?: string
    iconSrc?: string
    icon?: React.ReactNode
    onClick?: () => void
    height?: number
    width?: number | string
    sx?: SxProps<Theme>
}

const WaterTreeEditAction: React.FC<WaterTreeEditActionProps> = ({
    label = 'עריכת ויצירת עץ מים',
    iconSrc,
    icon,
    onClick,
    height,
    width,
    sx
}) => {
    const { mode } = useAppTheme()
    const isDarkMode = mode === 'dark'

    const colors = {
        bg: isDarkMode ? '#003089' : '#E3F5FF80', // Slightly transparent blue 
        text: isDarkMode ? '#FFFFFF' : '#003F61',
        hover: isDarkMode ? '#00266d' : '#E1F1FF',
        iconInvert: isDarkMode ? 'brightness(0) invert(1)' : 'none'
    }

    return (
        <Card
            onClick={onClick}
            sx={{
                width,
                height,
                display: 'flex',
                direction: 'rtl',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: "10px",
                bgcolor: colors.bg,
                px: 2,
                cursor: onClick ? 'pointer' : 'default',
                transition: 'all 120ms ease',
                '&:hover': { bgcolor: colors.hover, transform: 'translateY(-1px)' },
                '&:active': { transform: 'translateY(0)' },
                boxShadow: 'none',
                gap: 2, // Space between text and icon
                ...(Array.isArray(sx) ? sx : [sx])
            }}
        >
            <Typography sx={{ color: colors.text, fontSize: 13.5, fontWeight: 500, fontFamily: 'Rubik, sans-serif' }}>
                {label}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {icon
                    ? icon
                    : iconSrc
                        ? <img src={iconSrc} alt="" style={{ width: 22, height: 22, filter: colors.iconInvert }} />
                        : null}
            </Box>
        </Card>
    )
}

export default WaterTreeEditAction
